export const searchFieldCss = ({ className, overrideCss, } = {}) => {
    const searchField = [];
    const searchFieldInput = [];
    const searchFieldSearchIcon = [];
    const searchFieldCleanButton = [];
    if (!overrideCss) {
        searchField.push('search-field');
        searchFieldInput.push('search-field__input');
        searchFieldSearchIcon.push('search-field__search-icon');
        searchFieldCleanButton.push('search-field__clear-button');
    }
    if (className) {
        searchField.push(`${className}`);
        searchFieldInput.push(`${className}__input`);
        searchFieldSearchIcon.push(`${className}__search-icon`);
        searchFieldCleanButton.push(`${className}__clear-button`);
    }
    return {
        searchField: searchField.join(' '),
        searchFieldInput: searchFieldInput.join(' '),
        searchFieldSearchIcon: searchFieldSearchIcon.join(' '),
        searchFieldCleanButton: searchFieldCleanButton.join(' '),
    };
};
//# sourceMappingURL=searchFieldCss.js.map